import { Link } from "react-router-dom";
import { BookOpen, HandHeart, Users, CalendarDays, Sparkles, Compass, HeartPulse } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/Bits";

const ICONS = [BookOpen, HandHeart, Users, CalendarDays, HeartPulse, Compass, Sparkles];

const RESOURCES = [
  { title: "Weekly Sermons", desc: "The uncompromised Word of God, taught with clarity and conviction every week." },
  { title: "Prayer & Intercession", desc: "Standing in the gap for families, cities, and nations." },
  { title: "Leadership Conferences", desc: "Gatherings that ignite vision and equip leaders for their assignment." },
  { title: "Daily & Weekly Devotionals", desc: "Consistent nourishment for a thriving devotional life." },
  { title: "Healing & Deliverance", desc: "Ministering the freedom and wholeness found in Christ." },
  { title: "Leadership Mentorship", desc: "Personal investment into the next generation of Kingdom leaders." },
  { title: "Kingdom Discipleship", desc: "Structured programs that grow believers into mature disciples." },
];

export default function Ministry() {
  return (
    <div data-testid="ministry-page">
      <PageHero
        overline="House of Blessing Ministries"
        title={<>Advancing the Kingdom through the <span className="font-accent text-gold-gradient italic">Word of God.</span></>}
        subtitle="Committed to proclaiming the uncompromised Word of God while nurturing believers into mature disciples and effective Kingdom leaders."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-24">
        <Reveal className="mb-14">
          <Overline>Ministry Resources</Overline>
        </Reveal>
        <div className="grid gap-px bg-gold-500/15 border border-gold-500/15 md:grid-cols-2 lg:grid-cols-3">
          {RESOURCES.map((r, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={r.title} delay={(i % 3) * 0.06}>
                <div className="group h-full bg-ink p-9 transition-colors duration-500 hover:bg-ink-paper" data-testid={`ministry-card-${i}`}>
                  <Icon size={26} className="text-gold-500" strokeWidth={1.4} />
                  <h3 className="mt-7 font-serif text-2xl text-white">{r.title}</h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">{r.desc}</p>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.12}>
            <Link to="/contact" className="flex h-full flex-col justify-between bg-ink-royal p-9 transition-colors duration-500 hover:bg-ink-light" data-testid="ministry-invite">
              <span className="font-serif text-2xl text-gold-300">Invite us to your city →</span>
              <span className="mt-8 text-sm text-white/70">Host a conference, request training, or partner with the ministry.</span>
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-28">
        <Reveal>
          <div className="glass corner-frame p-10 md:p-16">
            <p className="font-accent italic text-2xl md:text-4xl leading-tight text-white">
              "We nurture believers into mature disciples and effective Kingdom leaders — that the
              Gospel would advance in every sphere of life."
            </p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
